import axiosInstance from "../utils/axiosInstance";
import { CookieUtils } from "../utils";

class DataService {
  async getProvinces() {
    const req = {
      operationName: null,
      query: `query MtiGetProvince {
        mtiGetProvince {
          success
          message
          payload {
            provinces {
              id
              code
              name_th
              name_en
              geography_id
            }
          }
        }
      }`,
      variables: null,
    };
    
    const accessToken = CookieUtils.getCookie("gtt_access_token");
    
    return axiosInstance
      .post("", req, { 
        headers: { 
          authorization: accessToken,
        } 
      })
      .then((res) => res.data.data.mtiGetProvince.payload || {});
  }
  async getAmphurTumbonZipCode({ sub_district, district, province, zip_code }) {
    const req = {
      operationName: null,
      query: `query MtiGetTumAmpPro($subDistrict: String, $district: String, $province: String, $zipCode: String) {
        mtiGetTumAmpPro(sub_district: $subDistrict, district: $district, province: $province, zip_code: $zipCode) {
          success
          message
          payload {
            province_id
            province
            province_en
            district_id
            district
            district_en
            sub_district_id
            sub_district
            sub_district_en
            zip_code
          }
        }
      }`,
      variables: {
        subDistrict: sub_district,
        district: district,
        province: province,
        zipCode: zip_code,
      },
    };
    
    // Get fresh tokens from cookies
    const accessToken = CookieUtils.getCookie("gtt_access_token");
    const ssoToken = CookieUtils.getCookie("gtt_sso_token");
    
    return axiosInstance
      .post("", req, { 
        headers: { 
          authorization: accessToken,
          gtt_sso_auth_token: ssoToken
        } 
      })
      .then((res) => res.data.data.mtiGetTumAmpPro.payload || {});
  }
  // async getCountry() {
  //   return Axios.get(`${REACT_APP_GTT_GQL_URL}api/country`).then((res) => res.data || {});
  // }
  async getTitle() {
    const req = {
      operationName: null,
      query: `query MtiGetInitialName {
        mtiGetInitialName {
          success
          message
          payload {
            value
            label
            gender
            lang
            type
          }
        }
      }`,
      variables: null,
    };
    
    const accessToken = CookieUtils.getCookie("gtt_access_token");
    
    return axiosInstance
      .post("", req, { 
        headers: { 
          authorization: accessToken,
        } 
      })
      .then((res) => res.data.data.mtiGetInitialName.payload || {});
  }
  async getNationalities() {
    const req = {
      operationName: null,
      query: `query MtiGetNationals {
        mtiGetNationals {
          success
          message
          payload {
            label
            value
          }
        }
      }`,
      variables: null,
    };
    
    const accessToken = CookieUtils.getCookie("gtt_access_token");
    
    return axiosInstance
      .post("", req, { 
        headers: { 
          authorization: accessToken
        } 
      })
      .then((res) => res.data.data.mtiGetNationals.payload || {});
  }
  async getOccupations() {
    const req = {
      operationName: null,
      query: `query MtiGetOccupation {
        mtiGetOccupation {
          success
          message
          payload {
            value
            label
            sort
            isRisk
          }
        }
      }`,
      variables: null,
    };
    
    const accessToken = CookieUtils.getCookie("gtt_access_token");
    
    return axiosInstance
      .post("", req, { 
        headers: { 
          authorization: accessToken,
        } 
      })
      .then((res) => res.data.data.mtiGetOccupation.payload || {});
  }
  async getCoverDetails({ product_code }) {
    const req = {
      operationName: null,
      query: `query MtiGetCoverDetail($productCode: String) {
        mtiGetCoverDetail(product_code: $productCode) {
          success
          message
          payload {
            order
            product_code
            package_code
            coverage_name
            insured
            cust_order
          }
        }
      }`,
      variables: {
        productCode: product_code,
      },
    };
    
    const accessToken = CookieUtils.getCookie("gtt_access_token");
    
    return axiosInstance
      .post("", req, { 
        headers: { 
          authorization: accessToken,
        } 
      })
      .then((res) => res.data.data.mtiGetCoverDetail.payload || {});
  }
}

export default new DataService();
